import * as joint from '@clientio/rappid';

// Maps AI equipment type names → JointJS shape namespace + class name
const SHAPE_MAP = {
    'Pump':               { ns: 'pfd',      cls: 'PumpObject' },
    'Vessel':             { ns: 'pfd',      cls: 'VesselObject' },
    'Feed':               { ns: 'pfd',      cls: 'FeedObject' },
    'HeatExchanger':      { ns: 'pfd',      cls: 'HeatXObject' },
    'MixerSplitter':      { ns: 'pipework', cls: 'MixerSplitterObject' },
    'Crusher':            { ns: 'pfd',      cls: 'crusherObject' },
    'Filter':             { ns: 'pfd',      cls: 'FilterObject' },
    'Settler':            { ns: 'pfd',      cls: 'SettlerObject' },
    'AgitatedVessel':     { ns: 'pfd',      cls: 'agitatedVesselObject' },
    'Thickener':          { ns: 'pfd',      cls: 'SettlerObject' },
    'Cyclone':            { ns: 'pfd',      cls: 'SolidSeparatorObject' },
    'Screen':             { ns: 'pfd',      cls: 'FilterObject' },
    'Flotation':          { ns: 'pfd',      cls: 'CircleObject' },
    'Dryer':              { ns: 'pfd',      cls: 'VesselObject' },
    'Kiln':               { ns: 'pfd',      cls: 'VesselObject' },
    'Crystallizer':       { ns: 'pfd',      cls: 'VesselObject' },
    'Evaporator':         { ns: 'pfd',      cls: 'VesselObject' },
    'DistillationColumn': { ns: 'pfd',      cls: 'DualDiamVesselObject' },
    'AbsorptionColumn':   { ns: 'pfd',      cls: 'DualDiamPackedVesselObject' },
    'Reactor':            { ns: 'pfd',      cls: 'agitatedVesselObject' },
    'FlashDrum':          { ns: 'pfd',      cls: 'VesselObject' },
    'Compressor':         { ns: 'pfd',      cls: 'CompressorObject' },
};

export function addEquipmentAt(rappid, type, x, y, label) {
    const shapeInfo = SHAPE_MAP[type];
    if (!shapeInfo) {
        console.warn(`addEquipmentAt: unknown type "${type}"`);
        return null;
    }

    const ShapeClass = joint.shapes[shapeInfo.ns]?.[shapeInfo.cls];
    if (!ShapeClass) {
        console.warn(`addEquipmentAt: shape class "${shapeInfo.ns}.${shapeInfo.cls}" not registered`);
        return null;
    }

    const cell = new ShapeClass({ isUnit: 'yes', unitType: type });
    cell.position(x, y);
    if (label) {
        cell.attr('shapename/innerHTML', `<p>${label}</p>`);
    }
    cell.addTo(rappid.graph);
    return cell.id;
}

export function getEquipmentBoundingBox(rappid) {
    const elements = rappid.graph.getElements().filter(
        (el) => el.attributes.isUnit === 'yes'
    );
    if (elements.length === 0) return null;

    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    elements.forEach((el) => {
        const { x, y } = el.position();
        const { width, height } = el.size();
        minX = Math.min(minX, x);
        minY = Math.min(minY, y);
        maxX = Math.max(maxX, x + width);
        maxY = Math.max(maxY, y + height);
    });

    return { x: minX, y: minY, width: maxX - minX, height: maxY - minY };
}
